/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/321-arrow-left2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M6.293 13.707l-5-5a.999.999 0 010-1.414l5-5a.999.999 0 111.414 1.414L4.414 7H14a1 1 0 010 2H4.414l3.293 3.293a.997.997 0 010 1.414.999.999 0 01-1.414 0z"/>'
  }
})
